<section class="videoSection">
    <div class="video-container" #videocontainer [innerHTML]="video?.content | safeHtml"></div>
    <div class="link-text">
        <a role="button" (click)="switchVideo($event)" [innerHTML]="video?.linkText" 
        [attr.aria-label]="video?.linkText"
        cdsButton="inlineLink" href="javascript:void(0)"
        ></a>
    </div>   
</section>